/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface ApiGetConfFieldv2V2ConfDeviceIdFieldNameGetRequest {
    deviceId: string;
    fieldName: string;
}

export interface ApiGetConfv2V2ConfDeviceIdGetRequest {
    deviceId: string;
}

/**
 * 
 */
export class ConfOauthApi extends runtime.BaseAPI {

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de token nécessaire sur v1
     * Api Get Conf Fieldv2
     */
    async apiGetConfFieldv2V2ConfDeviceIdFieldNameGetRaw(requestParameters: ApiGetConfFieldv2V2ConfDeviceIdFieldNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiGetConfFieldv2V2ConfDeviceIdFieldNameGet().'
            );
        }

        if (requestParameters['fieldName'] == null) {
            throw new runtime.RequiredError(
                'fieldName',
                'Required parameter "fieldName" was null or undefined when calling apiGetConfFieldv2V2ConfDeviceIdFieldNameGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/conf/{device_id}/{field_name}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));
        urlPath = urlPath.replace(`{${"field_name"}}`, encodeURIComponent(String(requestParameters['fieldName'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de token nécessaire sur v1
     * Api Get Conf Fieldv2
     */
    async apiGetConfFieldv2V2ConfDeviceIdFieldNameGet(requestParameters: ApiGetConfFieldv2V2ConfDeviceIdFieldNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetConfFieldv2V2ConfDeviceIdFieldNameGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de token nécessaire sur v1
     * Api Get Confv2
     */
    async apiGetConfv2V2ConfDeviceIdGetRaw(requestParameters: ApiGetConfv2V2ConfDeviceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling apiGetConfv2V2ConfDeviceIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2AuthorizationCodeBearer", []);
        }


        let urlPath = `/v2/conf/{device_id}`;
        urlPath = urlPath.replace(`{${"device_id"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Permet de récupérer la configuration d\'un équipement. Pas de token nécessaire sur v1
     * Api Get Confv2
     */
    async apiGetConfv2V2ConfDeviceIdGet(requestParameters: ApiGetConfv2V2ConfDeviceIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.apiGetConfv2V2ConfDeviceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
